import React, { useState } from 'react';
import './market.css';

const ORDINALS = ['', '1st', '2nd', '3rd', '4th', '5th'];

/** Player headshot (Sleeper CDN) with initials fallback; picks get a round badge. */
const MarketAvatar = ({ player, pick, size = 28 }) => {
  const [failed, setFailed] = useState(false);
  const box = { width: size, height: size };

  if (pick) {
    return (
      <span className="mk-ava badge" style={box} aria-hidden="true">
        {ORDINALS[pick.round] || 'PK'}
      </span>
    );
  }
  if (!player) return <span className="mk-ava badge" style={box} aria-hidden="true" />;
  if (!player.imageUrl || failed) {
    const initials = (player.name || '')
      .split(' ')
      .map((w) => w[0])
      .filter(Boolean)
      .slice(0, 2)
      .join('');
    return (
      <span className="mk-ava badge" style={box} aria-hidden="true">
        {initials}
      </span>
    );
  }
  return (
    <img
      className="mk-ava"
      style={box}
      src={player.imageUrl}
      alt=""
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
};

export default MarketAvatar;
